import { render, staticRenderFns } from "./CreateForm1.vue?vue&type=template&id=2b5ce0c8"
import script from "./CreateForm1.vue?vue&type=script&lang=js"
export * from "./CreateForm1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports